import styled from "styled-components";
export const CrmTagWrapper = styled.div`
  display: flex;
  width: fit-content;
  height: fit-content;
  border-radius: 5px;
  color: ${({ color }) => (color ? color : "#fff")};
  background-color: ${({ bgColor }) => (bgColor ? bgColor : "#000")};
  padding: 4px 8px;
  margin: 2px;
  h6 {
    transition: all 0.3s;
    margin: 0px;
    padding-bottom: 2px;
    font-size: 13px;
    width: fit-content;
  }
`;
